import type { DatetimeString } from '#/types/TypedDateString';
import { daysDifference } from '#/utils/string/datetime/datetimeStringCalculations';

export function isListingExpired({
  expires,
  now,
}: {
  expires: DatetimeString;
  now: DatetimeString;
}) {
  return new Date(expires) < new Date(now);
}

export type ListingTiming = {
  now: DatetimeString;
  isExpired: boolean;
  publishedDate: DatetimeString | null;
  isNew: boolean;
};

type Args = {
  now: DatetimeString;
  expires: DatetimeString;
  publishedDate: DatetimeString | null;
  isPreview: boolean;
};

export function listingTiming({
  now,
  expires,
  publishedDate,
  isPreview,
}: Args): ListingTiming {
  const isExpired = isListingExpired({ expires, now });

  return {
    now,
    isExpired,
    publishedDate,
    isNew: Boolean(
      !isExpired &&
      !isPreview &&
      publishedDate &&
      daysDifference(now, publishedDate) < 2,
    ),
  };
}
